import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import { Button } from './Button';
import './ContactForm.css';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if any field is empty
    if (!name.trim()) {
      alert('Please enter your name.');
      return;
    }

    if (!email.trim()) {
      alert('Please enter your email.');
      return;
    }

    if (!message.trim()) {
      alert('Please enter your message.');
      return;
    }

    setSubmitting(true);

    try {
      const response = await fetch('https://formspree.io/f/xgejvodq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          message,
        }),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setName('');
        setEmail('');
        setMessage('');
      }
    } catch (error) {
      console.error('Error:', error);
    }

    setSubmitting(false);
  };

  return (
    <div className="contact">
      <h2 className="contact-title">Contact Me!</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={name}
          onChange={handleNameChange}
        />
        {name.trim() === '' && <p className="error-message"></p>}
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={email}
          onChange={handleEmailChange}
        />
        {email.trim() === '' && <p className="error-message"></p>}
        <textarea
          name="message"
          placeholder="Your Message"
          value={message}
          onChange={handleMessageChange}
        ></textarea>
        {message.trim() === '' && <p className="error-message"></p>}
        <button type="submit" disabled={submitting}>
          {submitting ? 'Submitting...' : 'Submit'}
        </button>
        {submitSuccess && <p>Thank you for your message!</p>}
      </form>
    </div>
  );
};

export default ContactForm;
